import { Component } from '@angular/core';
import { APP_IMAGE, THEMEDATA } from 'src/app/shared/constants/app.constants';
import { GlobalService } from 'src/app/shared/services/global.service';
import { UtilService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-job-reservation-fail',
  templateUrl: './job-reservation-fail.component.html',
  styleUrls: ['./job-reservation-fail.component.scss']
})
export class JobReservationFailComponent {
  
  langDictionary:any;
  public heroImageURL: string = '../../../../assets/img/hero-default.webp';
  constructor(private _globalService: GlobalService,private scrollService: UtilService){
  }

  ngOnInit(){
    this.langDictionary = this._globalService.Language; 

    const themelist = THEMEDATA
     this.scrollService.img$.subscribe((strimage) => {
      const heroElement = document.querySelector('.hero') as HTMLElement;
      const appRoot = document.querySelector('app-root');
      // const themeData = themelist.find(item => item.themeId === newTheme?.trim().toUpperCase());

      
      if (heroElement) {
        const _strimage = ( strimage == '' || strimage == undefined || strimage == null)?"hero-default.webp":strimage;
        //this.heroImageURL = `url('../../../../assets/img/${strimage}')`
        // appRoot?.classList.add(themeData.cssClass);
        //       } else{
        

        if (!strimage) 
          {strimage = APP_IMAGE.HERO.DEFAULT;
          appRoot?.classList.add('theme-default-hero'); 
          }
        this.heroImageURL = strimage.toUpperCase().includes('HTTPS')? `url('${strimage}')`:`url('../../../../assets/img/${strimage}')`
       
        heroElement.style.setProperty('--hero-image', this.heroImageURL);
      }
    })
  }

}
